export { default as TenantContext, useAppTenantContext } from './context'
export { default as TenantContextProvider } from './TenantContextProvider'
export { default as useApplyTenant } from './useApplyTenant'

export const TENANT_LOCAL_STORAGE_KEY = 'ditto-tenant'
